import React from "react";

import { Dialog as MuiDialog, DialogProps, useMediaQuery, useTheme } from "@mui/material";

type Props = {
  responsiveWidth?: boolean;
};

export const DialogSx = ({ fullWidth, isMobile, responsiveWidth = false }: { fullWidth?: boolean; isMobile: boolean; responsiveWidth?: boolean }) => ({
  ".MuiDialog-paper": {
    margin: { xs: 1, sm: 4 },
    ...(Boolean(isMobile && fullWidth && !responsiveWidth) && { width: "auto" }),
  },
  ".MuiDialogContent-root": {
    px: { xs: 2, sm: 3 },
    pt: "8px !important",
    pb: 0,
  },
  ".MuiDialogTitle-root": {
    px: { xs: 2, sm: 3 },
    py: { xs: 2, sm: 2 },
    fontSize: { xs: "1.1rem", sm: "1.25rem" },
  },
  ".MuiDialogActions-root": {
    px: { xs: 2, sm: 3 },
    py: { xs: 2, sm: 3 },
  },
});

const Dialog: React.FC<DialogProps & Props> = ({ responsiveWidth, ...props }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <MuiDialog sx={{ ...DialogSx({ fullWidth: props.fullWidth, isMobile, responsiveWidth }) }} {...props}>
      {props.children}
    </MuiDialog>
  );
};

export default Dialog;
